import UI from 'root/ui';
import Cache from 'root/cache';
import View from 'view/base';
import View_Overview_Header from 'view/project/overview_header';
import View_Overview_Feedback from './feedback';
import View_Overview_Survey from './survey';

export default View.extend({
    tagName: 'section',

    views: {
        project_header: {},
        overview: {}
    },

    initialize: function() {
        this.views.project_header = new View_Overview_Header({
            model: Cache.getDefaultProject()
        });

        if (Cache.getDefaultProject().isFeedback()) {
            this.views.overview = new View_Overview_Feedback();
        } else {
            this.views.overview = new View_Overview_Survey();
        }
    },

    onPageReady: function() {
        // have an empty onPageReady for it to fire in the child views
    },

    render: function() {
        UI.setPageTitle('Overview');

        var content =
        '<div class="overview-header"></div>' +
        '<div class="overview-body"></div>';

        this.$el.html(content);

        this.views.project_header.render().$el.appendTo(this.$el.find('.overview-header'));
        this.views.overview.render().$el.appendTo(this.$el.find('.overview-body'));

        return this;
    }
});